module.exports = __webpack_public_path__ + "img/tree.b9d9c579.jpg";